var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _ellipse, _path9, _ellipse2, _path0, _path1, _g, _path10, _path11, _circle, _circle2, _path12, _path13, _path14, _path15, _path16, _path17;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoginImageColored(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 340,
    height: 223,
    fill: "none",
    fillRule: "evenodd"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M88.695 76.717c1.311 5.916-.06 9.956-4.115 12.122-4.055 2.165-7.398 3.78-10.03 4.845l27.992 9.906 9.324-9.906c-6.927-3.685-10.707-7.98-11.34-12.887-.632-4.905-4.576-6.266-11.831-4.08z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0461FC",
    d: "M59.606 186.665c-.795 14.914-.795 26.573 0 34.977h73.057c2.103-13.689 2.629-26.051 1.577-37.087-1.052-11.037-25.93-10.333-74.634 2.11z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00046D",
    strokeWidth: 0.715,
    d: "M104.892 203.367l-5.089 18.275M71.175 190.95c-1.03 11.35-.981 21.58.148 30.692"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#1CC5AA",
    d: "M71.148 123.39l-3.227 20.378c-8.033 3.635-17.254 4.05-27.662 1.245-1.682-29.926 9.639-47.073 33.962-51.441l2.551-.789c7.875 4.636 15.022 6.831 21.443 6.587 5.205-.269 9.492-2.292 12.861-6.07 9.953 2.137 18.066 6.459 24.34 12.968 1.814 2.033 3.646 4.86 5.495 8.479 1.667 3.1 2.733 4.787 3.2 5.059-3.125 10.697-8.18 17.264-15.163 19.703l-2.675-19.585-55.125 3.465z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1CC5AA",
    d: "M71.323 119.814c-8.209 41.92-12.313 65.632-12.313 71.137 30.067 8.862 55.293 7.517 75.677-4.037l-8.137-68.474-55.227 1.374z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#2BD2B7",
    d: "M45.76 221.642h4.195c7.652-32.606 3.91-55.304-11.227-68.095-12.802-9.72-24.46-11.072-34.974-4.059-4.454 3.665-4.945 8.709-1.471 15.132 3.517 6.282 10.725 13.202 21.626 20.762 10.9 7.56 18.184 19.646 21.851 36.26z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0461FC",
    d: "M43.022 221.642c-6.074-15.24-13.955-24.165-23.644-26.776-4.586-.78-7.275.089-8.067 2.607-.796 2.222.431 4.857 3.68 7.903 7.71 7.308 14.697 12.76 20.96 16.355l7.071-.09z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6DCFA",
    d: "M168.176 76.675l14.065-9.846a1.43 1.43 0 011.652.008L207 83.366a2.145 2.145 0 01.2 3.327L192.893 99.78c-.832.76-2.11.748-2.926-.028L168.01 78.883a1.43 1.43 0 01.165-2.208z"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 197.783,
    cy: 90.165,
    fill: "#FFF",
    opacity: 0.4,
    rx: 1.506,
    ry: 1.509
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00056D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M142.761 118.44c5.534 6.556 10.192 8.863 13.972 6.92 2.44-1.414 5.133-8.98 8.082-22.696l1.603-9.065c.362-5.554 2.136-9.444 5.324-11.67 4.78-3.34 5.414-3.137 6.467-3.137s.974 1.53-4.183 5.546l8.715 8.496a22.489 22.489 0 01-3.72 1.475c-1.224.357-1.837 1.182-1.84 2.475 1.405 31.064-.836 49.418-6.724 55.062-8.832 8.467-25.196 9.577-46.863-6.767-14.444-10.896-8.055-19.776 19.167-26.639z"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 183.545,
    cy: 58.477,
    fill: "#FFF",
    rx: 1.714,
    ry: 1.717
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeDasharray: "1.701822804782553,1.701822804782553",
    strokeWidth: 0.715,
    d: "M183.545 55.048v-8.62c0-11.852 9.608-21.46 21.46-21.46m5.507 0h22.834m-22.834 3.38h22.834m-22.834 3.582h22.834m-22.834 3.582h22.834m-22.834 3.582h22.834"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#C6DCFA",
    d: "M28.665 52.135l-7.86 18.082a1.43 1.43 0 00.76 1.89L46.79 82.629a1.43 1.43 0 001.757-.551L58.158 67a1.43 1.43 0 00-.565-2.047L30.617 51.427a1.43 1.43 0 00-1.952.708zM143.257 1.172L124.31 27.188a1.43 1.43 0 00.318 2.001l18.311 13.23a1.43 1.43 0 002.006-.334l18.364-25.968a1.43 1.43 0 00-.31-1.97L145.27.869a1.43 1.43 0 00-2.013.303z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(194.275 20.065)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00046D",
    d: "M53.495 34.983c-2.156-1.147-4.201-.375-6.136 2.318-2.902 4.04-3.646 8.623-6.508 11.72-2.862 3.097-10.999 9.836-9.773 17.573 1.227 7.737 1.425 17.513 0 20.87-.95 2.239 20.884 5.913 65.501 11.023v51.46c22.15 3.235 35.74-6.81 40.77-30.134 2.037-15.192-4.104-27.242-18.423-36.15-8.5-3.736-13.841-8.653-16.025-14.752-4.29-10.92-9.48-17.26-15.573-19.018-4.974-.981-8.604-3.198-10.89-6.65-5.329-11.049-12.976-13.802-22.943-8.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DCFA",
    d: "M117.95 1.476l5.95 14.549a1.43 1.43 0 01-.761 1.856l-27.38 11.691a1.43 1.43 0 01-1.986-1.203L92.67 14.347a1.43 1.43 0 01.744-1.37L115.944.76a1.43 1.43 0 012.006.716z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M52.58 62.067c1.963 6.011-3.005 10.704-14.905 14.08-11.9 3.374 3.491 6.728 46.173 10.061l-2.22-9.486c-11.893-3.126-17.39-9.697-16.492-19.712L52.58 62.067z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00056D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M28.341 113.185c-8.832 14.202-9.574 24.405-2.225 30.61 7.35 6.205 7.35 11.063 0 14.573C5.261 149.626-3.09 138.17 1.058 124.004c2.395-8.177 5.441-15.831 9.14-22.963 4.025 4.372 10.073 8.42 18.143 12.144z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00046D",
    d: "M23.353 162.177c-.55 17.34.692 30.474 3.725 39.4l70.516-.19c2.832-12.576 2.468-25.646-1.09-39.21-3.56-13.564-27.943-13.564-73.151 0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.715,
    d: "M56.401 181.22l4.95 20.357m17.586-33.893c3.45 5.165 8.926 8.201 16.426 9.107m-5.833-1.057c.951 12.146.951 20.76 0 25.843"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00046D",
    d: "M65.75 33.073c2.25-7.065 5.48-9.73 9.692-7.992 2.664 1.149 3.513 3.162 2.547 6.04-1.145 2.533-4.03 4.007-8.656 4.422-4.625.414-5.82-.409-3.583-2.47z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.715,
    d: "M79.93 31.542c-.463 3.302-3.94 4.812-10.431 4.529m4.139 3.357c3.132 4.333 7.412 7.015 12.837 8.046 8.138 1.547 14.125 4.992 20.096 14.564 5.97 9.571 10.767 14.97 26.425 20.342"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.715,
    d: "M58.816 36.971c6.334-2.126 10.567.043 12.7 6.508.92 4.567 3.836 7.56 8.748 8.982 8.114 3.194 13.218 8.252 15.313 15.173 2.002 7.546 6.495 12.99 13.48 16.333 8.426 4.559 14.214 10.352 17.364 17.379",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeWidth: 0.715,
    d: "M132.996 118.587c.07 7.23-2.784 13.652-8.562 19.264",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M60.94 54.049c2.713-2.93 4.772-3.662 6.178-2.197 2.108 2.197 1.222 4.271.61 5.272-.407.667-1.266 1.233-2.579 1.7-1.377 4.605-4.581 6.68-9.614 6.226-7.548-.682-8.05-7.437-8.45-10.238-2.86-.743-3.058-2.176-.595-4.298 1.547-1.796 2.354-3.516 2.422-5.16.101-2.466.69-6.842 3.657-6.842 1.308.203 2.017 2.053 2.126 5.55.318 4.887 2.4 8.216 6.245 9.987z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.715,
    d: "M50.473 47.661c.91-.395 1.788-.164 2.636.694"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 51.246,
    cy: 50.191,
    fill: "#00046D",
    rx: 1,
    ry: 1.074,
    transform: "rotate(13 51.246 50.19)"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.715,
    d: "M48.39 58.376c1.05.403 2.002.215 2.856-.566m11.751-2.52c.957-2.035 2.28-2.6 3.968-1.695"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2BD2B7",
    d: "M39.683 74.917c-14.33 3.734-24.35 12.848-30.06 27.344l18.335 10.56c-2.955 21.194-4.433 38.647-4.433 52.359 25.08 7.452 49.475 6.64 73.185-2.438-3.135-24.536-8.134-39.847-14.997-45.933l29.35 1.682C110.727 95.9 100.66 81.74 80.867 76.01c0 0-8.819 4.193-20.523 4.193-6.328 0-13.215-1.762-20.66-5.285z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#C6DCFA",
    d: "M2.127 99.701l16.311.454a2.86 2.86 0 012.607 1.878l10.525 28.809a1.43 1.43 0 01-1.343 1.92H14.43a2.86 2.86 0 01-2.677-1.853L.749 101.634a1.43 1.43 0 011.378-1.933z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00056D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M81.084 116.446c11.205-2.524 20.985-1.91 29.34 1.838-.62 15.853-6.88 27.969-18.778 36.346-10.544 6.012-24.23 4.772-41.06-3.722-6.929-4.127-12.697-8.292-17.306-12.495-2.182-2.255-4.228-3.37-6.139-3.346-2.86-.124-5.225-1.5-7.098-4.127-1.895-2.336-2.843-4.72-2.843-7.151 0-3.648 2.71-6.713 4.365-5.635 3.32 4.71 6.01 7.136 8.073 7.279l-2.615-7.324c2.754 2.207 4.832 4.375 6.235 6.503 1.63 2.53 3.33 4.016 5.098 4.456 2.653.66 31.274 9.865 36.088 3.893 3.617-5.019 5.83-10.524 6.64-16.515z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567,
    d: "M113.469 6.11l3.187 10.562m-7.131-8.388l2.388 10.003m-13.368-4.051l.81 5.707",
    opacity: 0.3
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00056D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M40.259 140.407c.505 19.442 5.035 32.12 13.59 38.037 12.831 8.875 33.887-6.962 44.443-19.018l7.645-9.572c5.728-1.065 10.16-2.721 13.296-4.97 0 0 1.434-1.074 6.608-2.329 0 0 1.661-.341 2.027-1.245.367-.903-.792-1.236-3.338-.903-1.698.222-3.039.222-4.022 0 6.89-2.377 10.166-4.105 9.827-5.186-.338-1.08-3.858-.393-10.558 2.062 6.434-2.52 9.484-4.263 9.148-5.226-.336-.964-3.656-.19-9.961 2.323 4.913-2.05 7.206-3.558 6.877-4.525-.329-.966-4.123.091-11.383 3.172 2.094-4.11 2.499-6.43 1.214-6.958 0 0-1.197-.28-2.47 2.9-.85 2.121-2 3.638-3.451 4.55-2.934 2.39-4.913 4.575-5.939 6.553 0 0-.768 1.378-8.395 4.269-5.084 1.927-13.373 5.269-24.865 10.026l-3.532-14.853-26.761.893z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.166,
    d: "M82.087 68.519c-.624 1.288-.833 2.443-.628 3.466.205 1.022.916 2.365 2.132 4.029l5.388 2.673c4.859 5.59 9.872 7.468 15.04 5.634 7.754-2.75 7.372-14.621.717-27.839-4.436-8.812-11.986-4.8-22.65 12.037z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 97.855,
    cy: 66.777,
    r: 1,
    fill: "#00046D"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 105.797,
    cy: 65.072,
    r: 1,
    fill: "#00046D"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00046D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.715,
    d: "M85.163 71.548c2.354.794 3.532 1.904 3.532 3.33 0 0 .027 1.417-1.386.425 0 0-1.009-.651-.38-1.701m15.613-9.395c2.317 3.392 3.475 5.464 3.475 6.214 0 .751-.579 1.272-1.737 1.564m-3.754 2.44c1.285 1.37 2.837 1.497 4.658.38m-9.872-10.598c.685-.852 1.822-1.278 3.41-1.278m4.459-.512c.39-1.208 1.335-1.611 2.836-1.208"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#00046D",
    d: "M81.09 56.018c.916-4.894 4.443-7.34 10.58-7.34 6.137 0 10.027-1.805 11.67-5.414 4.357 3.15 5.826 6.975 4.406 11.472 0 0-1.765 5.206-10.877 5.206 0 0-6.203-.247-6.809 2.28 0 0-.513.617 0 2.908s.937 3.295 0 5.89c0 0-3.593-3.413-5.92-1.042-2.328 2.371-.803 5.479 1.207 6.353 1.34.583 2.49.893 3.451.932.451 2.181.594 3.617.428 4.307 0 0-4.588-1.018-6.566-6.135 0 0-.63-2.814-2.787-4.416-2.157-1.601-4.48-6.23-3.381-10.077.732-2.565 2.265-4.206 4.598-4.924z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00056D",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.715,
    d: "M49.887 184.432c.404 5.284-.972 11.011-4.127 17.182m-20.275-22.852c6.747 1.6 11.996 4.994 15.747 10.18M21.85 161.423c17.174 15.967 25.762 36.04 25.762 60.219"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00056D",
    strokeWidth: 0.715,
    d: "M18.21 200.675c9.9 5.68 16.967 12.67 21.2 20.967"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    stroke: "#00046D",
    strokeWidth: 1.702,
    d: "M11.076 221.642H340"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.567,
    d: "M143.788 9.211l10.456 7.907m-13.504-2.936l10.147 7.45m-14.453-1.567l4.984 3.821M27.497 70.385l6.205-12.417m-.587 14.608l6.503-11.518m.478 14.649l3.43-6.047",
    opacity: 0.3
  })));
}
export default SvgLoginImageColored;